import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BottomNav from "@/components/BottomNav";
import { NotificationsProvider } from "@/contexts/NotificationsContext";

export default function MainLayout() {
  return (
    <NotificationsProvider>
      <div className="App min-h-screen flex flex-col bg-sand pb-14 md:pb-0">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <BottomNav />
      </div>
    </NotificationsProvider>
  );
}
